import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Info, X } from 'lucide-react';

interface Props {
  onAcknowledge: () => Promise<void>;
}

export default function PrivacyNoticeBanner({ onAcknowledge }: Props) {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);

  const handleDismiss = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await onAcknowledge();
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <div
      role="status"
      className="mb-5 rounded-lg border border-blue-300/30 bg-blue-500/5 px-4 py-3 text-sm text-blue-700 dark:text-blue-300 dark:border-blue-400/30"
    >
      <div className="flex items-start gap-2.5">
        <Info className="mt-0.5 h-4 w-4 shrink-0" />
        <p className="flex-1">
          <span className="font-semibold">
            {t('privacyNotice.title', 'Tratamiento de tus datos personales')}
          </span>
          {' — '}
          {t('privacyNotice.short', 'Tus datos (transcripciones, KPIs, puntuaciones) se tratan para tu formación profesional bajo la base jurídica de tu contrato laboral e interés legítimo (RGPD Arts. 6.1.b y 6.1.f). El responsable de tu equipo puede verlos.')}
          {' '}
          <Link
            to="/data-privacy"
            className="underline hover:text-blue-900 dark:hover:text-blue-100"
          >
            {t('legal.learnMore', 'Más información')}
          </Link>
        </p>
        <button
          onClick={handleDismiss}
          disabled={submitting}
          className="shrink-0 rounded-full p-0.5 hover:bg-blue-500/10 transition-colors disabled:opacity-50"
          aria-label={t('common.close', 'Cerrar')}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
